"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _LazyImage = require("../LazyImage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Image = ({
  alt,
  src,
  ...htmlImageElementProps
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
      ...htmlImageElementProps,
      alt: alt,
      "data-testid": getTestId(_common.IMAGE),
      role: "img",
      src: src
    })
  });
};
exports.Image = Image;
//# sourceMappingURL=Image.js.map